import React from 'react'
import { useTranslation } from "react-i18next"
import { Row, Col } from "react-bootstrap"
import CLabel from '../../../Common/CLabel'
import CardNemoItem from './CardNemoItem'

function PartyBodyCardBU(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_PartyItem = props.partyItem;
    const fontSize = { fontSize: "13px" }
    
    return (
        <>
            <Col style={fontSize} className="card-party-title">
                <h5>
                    <CardNemoItem text={ t('data-lang-lbl-bu') } />
                </h5>
            </Col>
            <Col style={fontSize} className="card-party-body">
                <Row>
                    <Col>
                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-code') } labelValue={ inputParam_PartyItem.partyCode }  />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-name') } labelValue={ inputParam_PartyItem.name } />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-businessunit') } labelValue={ inputParam_PartyItem.businessUnitName }  />
                    </Col>
                </Row>
            </Col>
        </>
    );
}

export default PartyBodyCardBU;